export const formatCpfCnpj = (value) => {
  const v = value.replace(/\D/g, "");

  if (v.length > 14) {
    return v
      .substring(0, 14)
      .replace(/^(\d{2})(\d)/, "$1.$2")
      .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
      .replace(/\.(\d{3})(\d)/, ".$1/$2")
      .replace(/(\d{4})(\d)/, "$1-$2");
  }

  if (v.length <= 11) {
    return v
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d{1,2})$/, "$1-$2");
  } else {
    return v
      .replace(/^(\d{2})(\d)/, "$1.$2")
      .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
      .replace(/\.(\d{3})(\d)/, ".$1/$2")
      .replace(/(\d{4})(\d)/, "$1-$2");
  }
};

export const formatCep = (value) => {
  return value
    .replace(/\D/g, "")
    .replace(/^(\d{5})(\d)/, "$1-$2")
    .substring(0, 9);
};

export const consultarCep = async (cep) => {
  const cleanCep = cep.replace(/\D/g, "");
  if (cleanCep.length !== 8) return null;

  try {
    const response = await fetch(`https://viacep.com.br/ws/${cleanCep}/json/`);
    const data = await response.json();
    if (data.erro) return null;
    return data;
  } catch (error) {
    console.error("Erro ao buscar CEP:", error);
    return null;
  }
};

export const formatTelefone = (value) => {
  const v = value.replace(/\D/g, "");

  if (v.length > 10) {
    return v.substring(0, 11).replace(/^(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
  } else if (v.length > 5) {
    return v.substring(0, 10).replace(/^(\d{2})(\d{4})(\d{0,4})/, "($1) $2-$3");
  } else if (v.length > 2) {
    return v.substring(0, 10).replace(/^(\d{2})(\d{0,5})/, "($1) $2");
  } else {
    return v;
  }
};

export const isEmailValid = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const formatContaContabil = (value) => {
  const v = value.replace(/\D/g, "").substring(0, 8);

  return v
    .replace(/^(\d{1})(\d)/, "$1.$2")
    .replace(/^(\d{1})\.(\d{2})(\d)/, "$1.$2.$3")
    .replace(/^(\d{1})\.(\d{2})\.(\d{2})(\d)/, "$1.$2.$3.$4");
};

export const formatValor = (value, finalize = false) => {
  if (value === null || value === undefined) return "";

  let v = String(value).trim();

  v = v.replace(/^R\$\s?/, "").replace(/\s/g, "");

  if (v.includes(",") && v.includes(".")) {
    v = v.replace(/\./g, "");
  } else if (v.includes(".") && !v.includes(",")) {
    v = v.replace(/\./g, ",");
  }

  v = v.replace(/[^\d,]/g, "");

  const firstComma = v.indexOf(",");
  if (firstComma !== -1) {
    v =
      v.slice(0, firstComma + 1) + v.slice(firstComma + 1).replace(/,/g, "");
  }

  let [integer, decimal = ""] = v.split(",");
  if (!integer) integer = "0";

  integer = integer.replace(/^0+(?=\d)/, "");

  const intFormatted = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

  decimal = decimal.slice(0, 2);

  if (finalize) {
    if (decimal.length === 0) decimal = "00";
    if (decimal.length === 1) decimal = decimal + "0";
    return `R$ ${intFormatted},${decimal}`;
  }

  if (v.includes(",")) {
    return `R$ ${intFormatted},${decimal}`;
  }

  return `R$ ${intFormatted}`;
};

export const formatMulta = (value, finalize = false) => {
  if (!value) return "";

  let v = value.replace(/[^\d,]/g, "");

  const parts = v.split(",");
  let integer = parts[0] ?? "";
  let decimal = parts.length > 1 ? parts.slice(1).join("") : null;

  if (integer.length > 1 && integer.startsWith("0")) {
    integer = integer.replace(/^0+/, "");
    if (integer === "") integer = "0";
  } else if (integer === "") {
    integer = "0";
  }

  const result = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

  if (decimal !== null) {
    if (finalize && decimal.length === 1) {
      return `${result},${decimal}0 %`;
    }
    return `${result},${decimal.substring(0, 2)} %`;
  }

  if (finalize) {
    return `${result},00 %`;
  }

  return `${result} %`;
};

export const formatNumber = (value, finalize = false) => {
  if (!value) return "";
  let v = value.toString().replace(/[^\d,]/g, "");
  const parts = v.split(",");
  let integer = parts[0];
  let decimal = parts.length > 1 ? parts.slice(1).join("") : null;

  if (integer.length > 1 && integer.startsWith("0")) {
    integer = integer.replace(/^0+/, "");
    if (integer === "") integer = "0";
  } else if (integer === "") {
    integer = "0";
  }

  const result = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

  if (decimal !== null) {
    if (finalize && decimal.length === 1) {
      return `${result},${decimal}0`;
    }
    return `${result},${decimal.substring(0, 2)}`;
  }

  if (finalize) {
    return `${result},00`;
  }

  return result;
};

export const formatDateBR = (dateStr) => {
  if (!dateStr) return "";

  const [year, month, day] = dateStr.split("-");

  return `${day}/${month}/${year}`;
};

export const isValidCPF = (cpf: string): boolean => {
  const cleanCPF = cpf.replace(/\D/g, "");
  if (cleanCPF.length !== 11 || /^(\n)\1{10}$/.test(cleanCPF)) return false;
  let sum = 0, rest;
  for (let i = 1; i <= 9; i++) sum += parseInt(cleanCPF.substring(i - 1, i)) * (11 - i);
  rest = (sum * 10) % 11;
  if (rest === 10 || rest === 11) rest = 0;
  if (rest !== parseInt(cleanCPF.substring(9, 10))) return false;
  sum = 0;
  for (let i = 1; i <= 10; i++) sum += parseInt(cleanCPF.substring(i - 1, i)) * (12 - i);
  rest = (sum * 10) % 11;
  if (rest === 10 || rest === 11) rest = 0;
  return rest === parseInt(cleanCPF.substring(10, 11));
};

export const isValidCNPJ = (cnpj: string): boolean => {
  const cleanCNPJ = cnpj.replace(/\D/g, "");
  if (cleanCNPJ.length !== 14 || /^(\d)\1{13}$/.test(cleanCNPJ)) return false;
  let size = cleanCNPJ.length - 2;
  let numbers = cleanCNPJ.substring(0, size);
  const digits = cleanCNPJ.substring(size);
  let sum = 0, pos = size - 7;
  for (let i = size; i >= 1; i--) {
    sum += parseInt(numbers.charAt(size - i)) * pos--;
    if (pos < 2) pos = 9;
  }
  let result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
  if (result !== parseInt(digits.charAt(0))) return false;
  size = size + 1;
  numbers = cleanCNPJ.substring(0, size);
  sum = 0;
  pos = size - 7;
  for (let i = size; i >= 1; i--) {
    sum += parseInt(numbers.charAt(size - i)) * pos--;
    if (pos < 2) pos = 9;
  }
  result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
  return result === parseInt(digits.charAt(1));
};


export const parseBRLToNumberSigned = (value) => {
  if (value === null || value === undefined || value === "") return 0;
  if (typeof value === "number") return value;

  let s = String(value).trim();

  const isNeg = s.includes("-");

  s = s
    .replace("R$", "")
    .replace(/\s/g, "")
    .replace(/\./g, "")
    .replace(",", ".")
    .replace(/[^0-9.]/g, ""); 

  const n = parseFloat(s) || 0;
  return isNeg ? -Math.abs(n) : n;
};

export const consultarCnpjHelper = async (valor, callback) => {
  const cnpjLimpo = valor.replace(/\D/g, "");

  if (cnpjLimpo.length !== 14) return;

  try {
    const response = await fetch(`https://brasilapi.com.br/api/cnpj/v1/${cnpjLimpo}`);
    if (!response.ok) throw new Error("CNPJ não encontrado");

    const data = await response.json();
    
    if (callback) callback(data);
    
  } catch (error) {
    console.error("Erro na consulta do CNPJ:", error);
  }
};